import { useAuthStore } from 'cloak-auth/src/Client/stores';
import { useEffect } from 'react';

import { RtcComponent } from 'kerberus-components/src/Components/Backend/RtcComponent';
import { useSessionsStore } from 'kerberus-components/src/Components/Backend/sessionsStore';
import { TauriRtcComponent } from 'kerberus-components/src/Components/Backend/TauriRtcComponent';

export function RtcContainer() {
    useEffect(() => {
        const abort = new AbortController();

        const handleRtcError = (error: unknown) => {
            if (error instanceof Error && error.name === 'AbortError') {
                return;
            }

            console.error(error);
        };

        useAuthStore
            .getState()
            .keyCloak?.updateToken(5)
            .then(() => {
                abort.signal.throwIfAborted();
                let publicDiscovery = false;
                const stored = localStorage.getItem('publicDiscovery');
                if (stored) {
                    try {
                        const parsed = JSON.parse(stored) as boolean;
                        publicDiscovery = parsed;
                    } catch (error) {
                        console.log(error);
                    }
                }
                if ('__TAURI_INTERNALS__' in window) {
                    const rtc = new TauriRtcComponent({
                        onSessions: (sessions) => {
                            useSessionsStore.setState({ sessions: sessions });
                        },
                        onUnauthorized: async () => {
                            const cloak = useAuthStore.getState().keyCloak!;
                            await cloak.updateToken(-1);
                            return cloak.token!;
                        },
                        publicDiscovery,
                        refreshToken: async () => {
                            console.log('Refreshing token in RTC');
                            const cloak = useAuthStore.getState().keyCloak!;
                            await cloak.updateToken(5);
                            return cloak.token!;
                        },
                        token: useAuthStore.getState().keyCloak!.token!,
                    });
                    useSessionsStore.setState({ publicDiscovery, rtc });
                } else {
                    const rtc = new RtcComponent({
                        onSessions: (sessions) => {
                            useSessionsStore.setState({ sessions: sessions });
                        },
                        onUnauthorized: async () => {
                            const cloak = useAuthStore.getState().keyCloak!;
                            await cloak.updateToken(-1);
                            return cloak.token!;
                        },
                        publicDiscovery,
                        refreshToken: async () => {
                            console.log('Refreshing token in RTC');
                            const cloak = useAuthStore.getState().keyCloak!;
                            await cloak.updateToken(5);
                            return cloak.token!;
                        },
                        signal: abort.signal,
                        token: useAuthStore.getState().keyCloak!.token!,
                    });
                    rtc.listening = true;
                    useSessionsStore.setState({ publicDiscovery, rtc });
                }
            })
            .catch(handleRtcError);

        return () => {
            const err = new Error('RTCContainer removed');
            err.name = 'AbortError';
            abort.abort(err);
            useSessionsStore.setState({ rtc: undefined });
        };
    }, []);

    return null;
}
